module.exports = __webpack_public_path__ + "img/activity-sheet_thumbnail_mouse.22891300.jpg";